<template>
  <vue-apex-charts
    type="area"
    height="260"
    :options="options"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

const HOURS = Array.from({ length: 24 }, (_, h) => `${String(h).padStart(2, '0')}h`)

export default {
  name: 'HourlyChart',
  components: { VueApexCharts },
  props: {
    today: { type: Array, default: () => [] },
    yesterday: { type: Array, default: () => [] },
    todayLabel: { type: String, default: '' },
    yesterdayLabel: { type: String, default: '' },
  },
  computed: {
    isDark() {
      return this.$store.state.appConfig.layout.skin === 'dark'
    },
    series() {
      // Hoje só até a hora atual: zeros futuros dariam a falsa ideia de queda
      const hour = new Date().getHours()
      return [
        { name: this.todayLabel, data: this.today.map((v, h) => (h <= hour ? v : null)) },
        { name: this.yesterdayLabel, data: this.yesterday },
      ]
    },
    options() {
      return {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
          animations: { enabled: false },
          foreColor: this.isDark ? '#d0d2d6' : '#5e5873',
          fontFamily: 'inherit',
        },
        colors: ['#7367f0', '#b4bdc6'],
        stroke: { curve: 'smooth', width: [3, 2], dashArray: [0, 5] },
        fill: { type: 'solid', opacity: [0.18, 0] },
        dataLabels: { enabled: false },
        legend: { position: 'top', horizontalAlign: 'right' },
        grid: { borderColor: this.isDark ? '#3b4253' : '#ebe9f1' },
        xaxis: { categories: HOURS, tickAmount: 12 },
        yaxis: { min: 0, forceNiceScale: true, labels: { formatter: v => Math.round(v) } },
        tooltip: { theme: this.isDark ? 'dark' : 'light', shared: true },
      }
    },
  },
}
</script>
